module.exports = __webpack_public_path__ + "img/CG.e2600f73.png";